export const fetchOpeningPuzzles = async(setPuzzles) => {
    console.log("[API Request] - fetchOpeningPuzzles")
    const puzzles = require('./opening_puzzles.json')
    setPuzzles(puzzles)
    return puzzles
}